import { merge } from 'lodash'
import themeSettings from '~/themes/base/settings'

const overloadSettings = {
  product: {
    price: {
      excludingVat: {
        enable: false, //
      },
    },
  },
  components: {
    ArticleBox: {
      articleInfo: {
        enable: true,
      },
      image: {
        height: 193,
        width: 193,
      },
      linkReadMore: {
        button: 'primary',
        enable: true,
      },
    },
    Breadcrumbs: {
      autoHideHomeIcon: false,
    },
    BreadcrumbFirstItem: {
      showIcon: false,
      showText: true,
    },
    Carousel: {
      leftIcon: 'right',
      rightIcon: 'right',
      showPartOfNextProduct: false,
    },
    CatalogSubCategories: {
      countPerLine: {
        sm: 2,
        md: 3,
        lg: 3,
        xl: 3,
      },
      enable: true,
      image: {
        width: 88,
        height: 80,
      },
    },
    CartInfoDropDownContent: {
      buttonCheckoutIcon: 'arrow-right',
    },
    CheckoutItemLine: {
      showOriginalPrice: true,
    },
    ContactBox: {
      sticky: {
        enable: true,
        stickyAt: 'vh',
      },
    },
    ContactBoxImage: {
      image: {
        height: 110,
        width: 110,
      },
    },
    FeaturedArticles: {
      image: {
        position: 'left', // top, left
      },
      linkAllArticles: {
        enable: true,
      },
      perLine: {
        lg: 2,
      },
    },
    FooterBottom: {
      paymentMethods: {
        enable: false,
      },
    },
    HeaderMain: {
      showContentColumn: false,
    },
    HeaderTop: {
      showRegistrationLink: false,
    },
    LanguageSwitcher: {
      enable: false, // Set `$languageSwitcherEnable` in `_variables.scss`
      type: 'flag',
      enableDownArrow: true,
    },
    MainMenuDropdownContent: {
      subcategoriesCountPerLine: {
        md: 2,
        lg: 3,
        xl: 3,
      },
    },
    NewsletterForm: {
      button: 'secondary',
    },
    PageAboutPurchase: {
      showAfterPurchase: false,
    },
    PageCatalog: {
      showUniqueSellingPoints: false,
    },
    PageHomepage: {
      featuredArticles: {
        count: 2,
      },
      showHomepageBranches: false,
    },
    PageHomepageMainHeading: {
      enable: false,
    },
    PageLogin: {
      registrationInfoButtonType: 'primary',
    },
    PageProductDetail: {
      enableConfigurator: true,
      parametersTable: {
        enable: true,
        showWeight: true,
        showCatalogCode: false,
        manufacturer: {
          code: true,
        },
        showItemAvailability: false,
        prices: {
          originalPrice: {
            enable: false,
            enableExcludingVAT: false,
          },
          price: {
            enableExcludingVAT: false,
          },
        },
      },
      showAvailability: false,
      showAvailabilityInWarehouses: false,
      showDeliveryOptions: false,
      showProductReviewsSummary: false,
      showRelatedCategories: true,
      showShortDescription: false,
    },
    ProductBox: {
      badge: {
        color: 'red', // see tags color palette + primary color
      },
      contentOrder: {
        image: 0,
        name: 1,
        availability: 2,
        price: 3,
      },
      forceDetailButton: true,
      showDescription: false,
    },
    ProductConfigurator: {
      addToCart: {
        multiplyPricesByQuantity: true,
        price: {
          withoutTax: false,
        },
      },
      sizes: {
        enable: true,
      },
    },
    ProductDetailImages: {
      badge: {
        color: 'green', // see tags color palette + primary color
      },
      image: {
        height: 415,
        width: 470,
      },
      thumbnail: {
        height: 70,
        width: 70,
      },
    },
    ProductsVisited: {
      enable: false,
    },
    SearchInput: {
      clearOnLoad: true,
      button: {
        show: true,
      },
    },
    Slider: {
      image: {
        height: 318, // Change SASSs variable $Slider-image-height
      },
      showTimerIndicator: false,
    },
    VerticalMenu: {
      enableHeader: false,
    },
    VerticalMenuItem: {
      iconClose: 'plus',
      iconOpen: 'minus',
    },
  },
  layouts: {
    LayoutBase: {
      showHeaderTop: false,
    },
  },
}

export default merge(themeSettings, overloadSettings)
